/**
 * Formate un montant en euros au format FR : "49,50 €".
 * - décimale = virgule
 * - espace insécable ( ) avant le €
 * - 2 décimales si non entier, 0 sinon
 */
export const formatEuros = (amount) => {
    if (amount === null || amount === undefined || Number.isNaN(Number(amount))) {
        return "—"
    }
    const value = Number(amount)
    const isInteger = Number.isInteger(value)
    const formatted = isInteger
        ? String(value)
        : value.toFixed(2).replace(".", ",")
    return `${formatted} €`
}
